module.exports = "<div class=\"sss-schedules grid-border-wrapper rounded\">\r\n  <slick-grid #grid [cssClasses]=\"['slickgrid-absolute', 'rounded']\" [data]=\"dataView\" [columns]=\"columns\" [options]=\"options\"></slick-grid>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/buffer-graph/components/suppliers-schedules.component/suppliers-schedules.component.html
// module id = ./src/app/buffer-graph/components/suppliers-schedules.component/suppliers-schedules.component.html
// module chunks = main